import React from 'react'
import PropTypes from 'prop-types'
import MainNavBar from 'components/organisms/mainNavBar/view'
import PublicNavBar from 'components/organisms/publicNavBar/view'
import { Container, Content, MainContent, Footer } from './styled'
import { Typography, Box, Link, IconButton, Grid, Divider } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const LayoutView = ({
  children,
  theme,
  profile,
}) => (
  <Container>
    {profile ? <MainNavBar /> : <PublicNavBar />}
    <Content>
      <MainContent>
        {React.cloneElement(children, { theme, profile })}
      </MainContent>
    </Content>
    <Footer>
      <Box
        component="footer"
        sx={{
          backgroundColor: theme.palette.grey[100],
          padding: '40px 20px',
        }}
      >
        <Grid container spacing={3} justifyContent="center">
          {/* Company Info Column */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6" color="primary" gutterBottom>
              Hive Space
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Find your perfect workspace at the best price
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Email: hello@hivespace.co
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton
                color="primary"
                aria-label="linkedin"
                size="small"
                component="a"
                href="https://www.linkedin.com/company/hivespace-co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                color="primary"
                aria-label="facebook"
                size="small"
                component="a"
                href="https://www.facebook.com/hivespaceco"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                color="primary"
                aria-label="instagram"
                size="small"
                component="a"
                href="https://www.instagram.com/hive.space"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links Column */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6" color="primary" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="/"
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Home
              </Link>
              <Link
                href="/booking-find"
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Find Spaces
              </Link>
              <Link
                href="/about-us"
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                About Us
              </Link>
              <Link
                href="/contact-us"
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Help Center
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ textAlign: 'center' }}>
          <Link
            href="/cookie-policy"
            sx={{
              mr: 2,
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { color: 'primary.main' }
            }}
          >
            Cookie Policy
          </Link>
          <Link
            href="/terms-of-service"
            sx={{
              mr: 2,
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { color: 'primary.main' }
            }}
          >
            Terms of Service
          </Link>
          <Typography variant="body2" color="text.secondary" display="inline">
            © {new Date().getFullYear()} Hive B Ltd. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </Footer>
  </Container>
)

LayoutView.defaultProps = {
  children: <></>,
  breadcrumb: true,
  profile: null,
}

LayoutView.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object.isRequired,
  breadcrumb: PropTypes.bool,
  profile: PropTypes.object,
}

export default LayoutView